import { Dispatch } from "redux";
import { EmailAddressActionTypes } from "./types";

export interface EmailAddressActions {
  type: EmailAddressActionTypes;
  payload: string;
}

export const emailAddressActions = {
  addEmailAddress: (emailAddress: string) => {
    return (dispatch: Dispatch) => {
      dispatch<EmailAddressActions>({
        type: EmailAddressActionTypes.ADD_EMAIL_ADDRESS,
        payload: emailAddress
      });
    };
  }
};
